module.exports = __webpack_public_path__ + "img/iotwise2.602f69df.png";